export class GridPagination {
  limit: number;
  offset: number;
  sort: string;
  sortOrder: string;
}
